import API from '../utils/api';
export const getOrderDetailsById = (orderId) => {
  return API.get(`/admin/order-items/${orderId}`);
}